<template>
  <div class="tag-picker">
    <transition name="fade">
      <ul ref="picker" v-if="open" class="tag-picker-picker">
        <li class="tag-picker-option" v-for="ptag in tagList" :key="ptag._id">
          <a
            class="tag-picker-option-link"
            :class="{ active: ptag._id === tag?._id }"
            href="#"
            @click.prevent.stop="pick(ptag)"
          >
            {{ ptag.name }}
          </a>
        </li>
      </ul>
    </transition>
    <a class="handler" href="#" @click.prevent.stop="open = true">
      <chevron-down-icon /> {{ label }}
    </a>
  </div>
</template>

<script lang="ts">
import { Tag } from "@/models";
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";

@Options({
  components: {
    ChevronDownIcon,
  },
  props: {
    tag: {
      type: Object,
    },
  },
  computed: {
    ...mapState("projects", ["tags"]),
  },
  data() {
    return {
      open: false,
    };
  },
})
export default class TagPicker extends Vue {
  open!: boolean;
  tag?: Tag;
  tags!: Record<string, Tag>;

  get tagList() {
    const tl = Object.values(this.tags);
    tl.sort((a, b) => {
      if (a.name > b.name) return 1;
      if (a.name < b.name) return -1;
      return 0;
    });
    return tl;
  }

  get label() {
    return this.tag ? this.tag.name : "Pick a tag";
  }

  mounted(): void {
    window.addEventListener("mousedown", this.onMouseDown);
  }

  beforeUnmount(): void {
    window.removeEventListener("mousedown", this.onMouseDown);
  }

  onMouseDown(e: MouseEvent) {
    if (!this.open) return;
    const picker = this.$refs.picker as HTMLElement;
    let node: HTMLElement | null = e.target as HTMLElement;
    while (node) {
      if (node === picker) {
        return;
      }
      node = node.parentElement;
    }
    this.open = false;
  }

  pick(tag: Tag) {
    this.open = false;
    this.$emit("pick", tag);
  }
}
</script>

<style lang="scss">
.tag-picker {
  width: 180px;
  box-sizing: border-box;
  position: relative;
  padding: 9px 0;

  a.handler {
    color: black;
    text-decoration: none;
    svg {
      width: 14px;
      position: relative;
      top: 3px;
    }
  }

  .tag-picker-picker {
    box-sizing: border-box;
    position: absolute;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, #f0f0f0 0%, #d0d0d0 100%);
    border: 1px solid #999;
    z-index: 10;
  }
}

.tag-picker-option {
  .tag-picker-option-link {
    display: block;
    padding: 4px 8px;
    color: black;
    text-decoration: none;

    &.active {
      background-color: #ccc;
    }
    &:hover {
      background-color: #999;
      color: white;
    }
  }
}
</style>
